module.exports = "#acertsAnswers {\n  display: inline; }\n\n::ng-deep .mat-tooltip {\n  font-size: 14px; }\n"